import { defineComponent as _defineComponent } from 'vue'
import { FE_VERSION } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'jhi-footer',
  setup(__props) {

const version = 'v' + FE_VERSION;
const year = new Date().getFullYear();

return { __sfc: true,version, year }
}

})